/**
 * Whether an intro / explainer panel is collapsed. Once the user opens or
 * closes it, their choice wins; until then it follows the venue's data, so it
 * starts collapsed for venues already using the feature (and still opens for
 * new ones once data has loaded).
 *
 * @param {{ userChoice: boolean | null | undefined, hasData: boolean }} options
 * @returns {boolean}
 */
export const introCollapsedByDefault = ({ userChoice, hasData }) =>
  typeof userChoice === 'boolean' ? userChoice : Boolean(hasData)
